import { render, staticRenderFns } from "./ContextMenuDivider.vue?vue&type=template&id=0e55506d&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports